module.exports = __webpack_public_path__ + "img/system4.5111a6f9.png";